import actionTypes from 'reduxStore/actionTypes'

export const modalTypes = {
  ADMIN: 'ADMIN',
}

const initialState = {
  [modalTypes.ADMIN]: {
    active: false,
  },
}

export default (state = initialState, action) => {
  const { modalType, type } = action
  switch (type) {
    case actionTypes.OPEN_MODAL:
      console.log(action)
      return { ...state, [modalType]: { active: true } }
    case actionTypes.CLOSE_MODEL:
      return { ...state, [modalType]: { active: false } }
    default:
      return state
  }
}
